import { render, staticRenderFns } from "./CrossSellAccessories.vue?vue&type=template&id=1ddbe924&scoped=true&"
import script from "./CrossSellAccessories.vue?vue&type=script&lang=js&"
export * from "./CrossSellAccessories.vue?vue&type=script&lang=js&"
import style0 from "./CrossSellAccessories.vue?vue&type=style&index=0&id=1ddbe924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddbe924",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ddbe924')) {
      api.createRecord('1ddbe924', component.options)
    } else {
      api.reload('1ddbe924', component.options)
    }
    module.hot.accept("./CrossSellAccessories.vue?vue&type=template&id=1ddbe924&scoped=true&", function () {
      api.rerender('1ddbe924', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/components/CrossSellAccessories.vue"
export default component.exports